<div class="mobile-top-banner" [class.mobile-top-banner--home]="showHomeImages">
    @if (showBackButton) {
    <div class="large-wrapper mobile-top-banner-wrapper">
        <ion-icon
            name="arrow-back-outline"
            type="button"
            class="mobile-top-banner-back"
            (click)="goBack()"
        >
        </ion-icon>
    </div>
    } @if (showHomeImages) {
    <img
        src="assets/images/mobile-header-clouds.png"
        class="mobile-top-banner-clouds"
        alt=""
    />
    <div class="mobile-home-actions">
        @if (userService.isLoggedIn) {
        <div class="notification-bell-wrapper" (click)="goToNotifications()">
            <ion-icon
                name="notifications-outline"
                class="notification-bell-icon"
            ></ion-icon>
            @if (notificationBadgeCount > 0) {
            <ion-badge color="danger" class="notification-badge">
                {{
                    notificationBadgeCount > 99 ? "99+" : notificationBadgeCount
                }}
            </ion-badge>
            }
        </div>
        }
    </div>
    <img
        src="assets/images/logo-image.png"
        class="mobile-top-banner-logo pointer"
        alt=""
        (click)="goHome()"
    />
    <div class="mss-main-toolbar-action__icon" (click)="goToAccount()">
        <img alt="MySupportSpace Profile" src="assets/icons/profile_icon.png" />
    </div>
    }
</div>
